import React from 'react';
import { Form, Modal, Switch } from 'antd';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  acceptAnalytics,
  acceptMarketing,
  declineAnalytics,
  declineMarketing,
} from '../../../redux/slices/localStorageSlice';

const CookiesModal = ({ visible, onCancel }) => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const areMarketingAccepted = useSelector(
    (state) => state.localStorage.areMarketingAccepted,
  );
  const areAnalyticsAccepted = useSelector(
    (state) => state.localStorage.areAnalyticsAccepted,
  );

  return (
    <Modal
      width={800}
      title={t('Používateľské nastavenia súborov cookie')}
      open={visible}
      onCancel={() => onCancel && onCancel()}
      footer={null}
    >
      <div className="accept-message">
        {t(
          'Používame súbory cookies, aby sme Vám zabezpečili čo najlepší zážitok z návštevy nášho webového portálu. Ak odmietnete používanie súborov cookies, tento web nemusí fungovať správne. Viac informácií nájdete na ',
        )}
        <a
          className={'link'}
          target={'_blank'}
          rel="noreferrer"
          href="https://www.uniza.sk/index.php?option=com_content&view=article&id=2793:cookies&catid=2"
        >
          {t('stránke univerzity o cookies')}
        </a>
        .
      </div>
      <Form
        style={{
          marginTop: '20px',
        }}
        layout="vertical"
      >
        <Form.Item label={t('Základné')}>
          {t(
            'Tieto položky sú potrebné na povolenie základných funkcií webových stránok.',
          )}
          <br />
          <Switch
            disabled
            checked={true}
            checkedChildren={t('Prijať')}
            unCheckedChildren={t('Odmietnuť')}
          />
        </Form.Item>
        <Form.Item label={t('Google Analytics')}>
          {t(
            'Nástroje používané na analýzu údajov na meranie efektívnosti webovej lokality a na pochopenie jej fungovania.',
          )}
          <br />
          <Switch
            checked={areAnalyticsAccepted}
            checkedChildren={t('Prijať')}
            unCheckedChildren={t('Odmietnuť')}
            onChange={(value) => {
              if (value) {
                window.grantAnalyticsCookies();

                dispatch(acceptAnalytics());
              } else {
                window.denyAnalyticsCookies();

                dispatch(declineAnalytics());
              }
            }}
          />
        </Form.Item>
        <Form.Item label={t('Google Marketing')}>
          {t(
            'Súbor techník, ktorých cieľom je obchodná stratégia a najmä štúdium trhu.',
          )}
          <br />
          <Switch
            checked={areMarketingAccepted}
            checkedChildren={t('Prijať')}
            unCheckedChildren={t('Odmietnuť')}
            onChange={(value) => {
              if (value) {
                window.grantMarketingCookies();

                dispatch(acceptMarketing());
              } else {
                window.denyMarketingCookies();

                dispatch(declineMarketing());
              }
            }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CookiesModal;
